var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandStepupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E7FAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33H31",
    stroke: "#084B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 24.75H24M24.25 24.75C24.25 24.8881 24.1381 25 24 25C23.8619 25 23.75 24.8881 23.75 24.75C23.75 24.6119 23.8619 24.5 24 24.5C24.1381 24.5 24.25 24.6119 24.25 24.75Z",
    stroke: "#084B32",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9152 19.6109L25.8078 17.3818C25.019 15.7939 24.6246 15 24 15C23.3754 15 22.981 15.7939 22.1922 17.3818L21.0848 19.6109C20.5811 20.6249 20.3292 21.132 19.8798 21.2461C19.8485 21.254 19.8169 21.2604 19.785 21.2653C19.3268 21.3357 18.8992 20.9668 18.0439 20.2289C16.0124 18.4763 14.9966 17.6 14.3803 17.949C14.3405 17.9716 14.3021 17.9969 14.2657 18.0247C13.702 18.4544 14.0954 19.7414 14.8823 22.3153L16.0478 26.1279C16.471 27.5121 16.6826 28.2042 17.2179 28.6021C17.7532 29 18.4726 29 19.9115 29L28.0886 28.9999C29.5274 28.9999 30.2468 28.9999 30.7821 28.602C31.3175 28.2041 31.529 27.512 31.9522 26.1279L33.1177 22.3153C33.9046 19.7414 34.298 18.4544 33.7344 18.0247C33.6979 17.9969 33.6595 17.9716 33.6197 17.949C33.0034 17.6001 31.9876 18.4764 29.9561 20.229C29.1008 20.9668 28.6732 21.3357 28.215 21.2653C28.1831 21.2604 28.1515 21.254 28.1202 21.2461C27.6708 21.132 27.4189 20.6249 26.9152 19.6109Z",
    stroke: "#084B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandStepupIcon);
export default __webpack_public_path__ + "static/media/brand-stepup-icon.8dfef2c64d8a9ab21bb58f1986627f23.svg";
export { ForwardRef as ReactComponent };